export const NavPath = {
    splash: "/",
    who: "/who",
    what: "/what",
    breakdown: "/breakdown",
    outcomes: "/outcomes",
}